import '../scss/index.scss';
import { components } from './components/index.js';

window.components = components;
